import styled from 'styled-components'
import { Link } from '@navent-jobs/ui-kit/components/link'

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    flex-direction: row;
    justify-content: space-between;
  }

  & a:hover {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.primary.normal};
    cursor: pointer;
  }
`

export const ImageWrapper = styled.div`
  width: 100%;
  max-width: 560px;
  display: flex;
  justify-content: center;

  @media (min-width: ${({ theme }) => theme.screen.mdmMin}) {
    justify-content: flex-start;
  }
`

export const TextWrapper = styled.div`
  width: 100%;
  max-width: 667px;
  margin: 32px 0px 24px;
  padding: 0 4px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    margin: 50px 0px;
  }
`

export const Image = styled.div`
  background-image: url(${({ bg }) => bg});
  background-repeat: no-repeat;
  background-position: top;

  background-size: contain;
  width: 100%;

  height: 100%;
  min-height: 250px;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    min-height: 296px;
  }

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    max-width: auto;
    background-position: left;
    background-size: cover;
  }

  @media (min-width: ${({ theme }) => theme.screen.xlMin}) {
    background-position: center;
  }
`

export const TitleWrapper = styled.div`
  margin-bottom: 24px;
`

export const List = styled.ul`
  padding: 0px;
  margin: 0px 0px 32px 0px;

  & li {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0px;
    }
  }
`

export const Item = styled.li`
  display: flex;
  align-items: flex-start;

  & span {
    margin: 0px 0px 0px 12px;
  }
`

export const CustomLink = styled(Link)`
  min-width: 160px;
`
export const LinkWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  @media (min-width: ${({ theme }) => theme.screen.xlMin}) {
    justify-content: flex-start;
  }
`
export const SectionToRigth = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`
